"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCouponDiscount = exports.getCouponMessage = exports.getBxGyFreeQuantity = exports.getBxAyOnQuantity = void 0;
const _1 = require(".");
const product_1 = require("../helpers/product");
const types_1 = require("../types");
const cart_1 = require("../types/cart");
const getBxAyOnQuantity = (buyXQuantity, cartList, discountItemThreshold) => {
    const totalItems = (0, _1.getCartCount)(cartList);
    const thresholdLessItemCount = Math.floor(totalItems / buyXQuantity) * buyXQuantity;
    if (!discountItemThreshold) {
        // if not defined then zero value which means there is no cap (limit) on quantity
        return thresholdLessItemCount;
    }
    return Math.min(thresholdLessItemCount, discountItemThreshold);
};
exports.getBxAyOnQuantity = getBxAyOnQuantity;
const getBxGyFreeQuantity = (getYQuantity, buyXQuantity, cartList, discountItemThreshold) => {
    const totalItems = (0, _1.getCartCount)(cartList);
    const thresholdLessItemCount = Math.floor((totalItems -
        (totalItems * (buyXQuantity || 1)) /
            ((buyXQuantity || 1) + (getYQuantity || 1))) /
        (getYQuantity || 1)) * (getYQuantity || 1);
    if (!discountItemThreshold) {
        // if not defined then zero value which means there is no cap (limit) on quantity
        return thresholdLessItemCount;
    }
    return Math.min(thresholdLessItemCount, discountItemThreshold);
};
exports.getBxGyFreeQuantity = getBxGyFreeQuantity;
const getCouponMessage = ({ couponType, buyXQuantity, getYAmount, getYPercentage, getYQuantity: gyq, paymentMethod, getYStoreProducts, minOrderValue, maxDiscount, }) => {
    var _a, _b;
    const getYQuantity = gyq || 1;
    let discountMsg = "Lowest value item in the cart will be discounted off on the item total";
    const freeGiftsLength = (_a = (getYStoreProducts || [])) === null || _a === void 0 ? void 0 : _a.length;
    if (couponType === types_1.CouponType.FIXED) {
        discountMsg = `₹${getYAmount} off from total ${!!freeGiftsLength ? `+ Get ${freeGiftsLength} Free Gifts!` : ""}`;
    }
    else if (couponType === types_1.CouponType.PERCENTAGE) {
        discountMsg = `${getYPercentage}% off from total ${!!freeGiftsLength ? `+ Get ${freeGiftsLength} Free Gifts!` : ""}`;
        if (maxDiscount) {
            discountMsg = `${discountMsg} upto ₹${maxDiscount}`;
        }
    }
    else if (couponType === types_1.CouponType.BUY_X_GET_Y && getYQuantity > 1) {
        discountMsg = `${getYQuantity} items with the lowest value will be given away for free! ${!!freeGiftsLength ? `+ Get ${freeGiftsLength} Free Gifts!` : ""}`;
        if (maxDiscount) {
            discountMsg = `${discountMsg} upto ₹${maxDiscount}`;
        }
    }
    else if (couponType === types_1.CouponType.PRODUCT) {
        const titles = (getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.map((item) => item === null || item === void 0 ? void 0 : item.title)) || [];
        const result = titles.length
            ? titles.length > 1
                ? `${titles.slice(0, -1).join(", ")} and ${titles.at(-1)}`
                : titles[0]
            : "";
        const totalFreeProductsPrice = (_b = getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.filter(Boolean)) === null || _b === void 0 ? void 0 : _b.reduce((acc, item) => { var _a; return acc + (((_a = (0, product_1.getProductPrice)(item)) === null || _a === void 0 ? void 0 : _a.price) || 0); }, 0);
        discountMsg = `FREE ${result}${totalFreeProductsPrice ? ` WORTH ₹${totalFreeProductsPrice}` : ""}`;
    }
    else if (couponType === types_1.CouponType.BUY_X_AT_Y) {
        discountMsg = `Buy ${buyXQuantity} @ ₹${getYAmount} ${!!freeGiftsLength ? `+ Get ${freeGiftsLength} Free Gifts!` : ""}`;
    }
    if (minOrderValue) {
        discountMsg = `${discountMsg} on orders above ₹${minOrderValue}.`;
    }
    else {
        discountMsg = `${discountMsg}.`;
    }
    let paymentTypeMsg = "Applicable on both COD and online payment.";
    if (paymentMethod === types_1.CouponPaymentMethod.COD) {
        paymentTypeMsg = "Applicable on COD.";
    }
    else if (paymentMethod === types_1.CouponPaymentMethod.ONLINE) {
        paymentTypeMsg = "Applicable on online payment.";
    }
    return {
        message: `${discountMsg} ${paymentTypeMsg}`,
        paymentTypeMsg,
        discountMsg,
    };
};
exports.getCouponMessage = getCouponMessage;
const getCouponDiscount = (coupon, cartItems, isNumber) => {
    var _a;
    if (!coupon) {
        return { coupon: null, allowed: false, discount: 0, message: null };
    }
    const { minOrderValue: mov, couponType, maxDiscount, buyXQuantity: bxq, applicableCollections, applicableProducts, getYAmount, getYPercentage, getYQuantity: gyq, getYStoreProducts, applyOnAllVariants = false, discountItemThreshold = 0, } = coupon || {};
    const buyXQuantity = bxq || 1;
    const getYQuantity = gyq || 1;
    const finalGetYQty = couponType === types_1.CouponType.BUY_X_GET_Y ? getYQuantity : 0;
    const minOrderValue = couponType === types_1.CouponType.BUY_X_AT_Y
        ? Math.max(mov !== null && mov !== void 0 ? mov : 0, getYAmount !== null && getYAmount !== void 0 ? getYAmount : 0)
        : mov;
    const cartList = cartItems.filter((c) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const isCouponItem = c.cartItemSource === cart_1.CartItemSource.COUPON ||
            c.cartItemSource === cart_1.CartItemSource.LIMITED_TIME_DEAL;
        if (isCouponItem)
            return false;
        const isProductApplicable = Array.isArray(applicableProducts) && applicableProducts.length
            ? applicableProducts.includes(c.id)
            : true;
        if (!isProductApplicable)
            return false;
        const variantIds = ((_b = (_a = c.variants) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length)
            ? (_c = c === null || c === void 0 ? void 0 : c.variants) === null || _c === void 0 ? void 0 : _c.items.map((i) => i.id)
            : [];
        const checkForVariantApplicable = applyOnAllVariants
            ? c.variantId && !variantIds.includes(c.variantId)
            : (c === null || c === void 0 ? void 0 : c.variantId) !== ((_e = (_d = c === null || c === void 0 ? void 0 : c.variants) === null || _d === void 0 ? void 0 : _d.items[0]) === null || _e === void 0 ? void 0 : _e.id);
        if (couponType === types_1.CouponType.BUY_X_AT_Y &&
            ((_g = (_f = c.variants) === null || _f === void 0 ? void 0 : _f.items) === null || _g === void 0 ? void 0 : _g.length) &&
            checkForVariantApplicable) {
            return false;
        }
        const isCollectionApplicable = Array.isArray(applicableCollections) && applicableCollections.length
            ? applicableCollections.some((ac) => (c.collections || []).includes(ac))
            : true;
        return isCollectionApplicable;
    });
    const totalAmount = (0, _1.getTotalPrice)(cartList);
    if (couponType !== types_1.CouponType.BUY_X_AT_Y &&
        couponType !== types_1.CouponType.BUY_X_GET_Y &&
        minOrderValue &&
        minOrderValue > totalAmount) {
        return {
            coupon,
            allowed: false,
            discount: 0,
            message: `Add product worth ₹${minOrderValue - totalAmount} more to the cart to avail this offer`,
        };
    }
    const totalItems = (0, _1.getCartCount)(cartList);
    if (buyXQuantity + finalGetYQty > totalItems) {
        return {
            coupon,
            discount: 0,
            allowed: false,
            message: isNumber
                ? buyXQuantity + finalGetYQty - totalItems
                : `Add ${buyXQuantity + finalGetYQty - totalItems} more items to the cart to avail this offer`,
        };
    }
    if (Array.isArray(applicableProducts) && applicableProducts.length) {
        const hasProduct = cartItems
            .filter((c) => c.cartItemSource !== cart_1.CartItemSource.COUPON)
            .some((c) => applicableProducts.includes(c.id));
        if (!hasProduct) {
            return {
                coupon,
                discount: 0,
                allowed: false,
                message: `Not applicable on the products in the cart.`,
            };
        }
    }
    if (Array.isArray(applicableCollections) && applicableCollections.length) {
        const hasCollection = cartItems
            .filter((c) => c.cartItemSource !== cart_1.CartItemSource.COUPON)
            .some((c) => applicableCollections.some((ac) => (c.collections || []).includes(ac)));
        if (!hasCollection) {
            return {
                coupon,
                discount: 0,
                allowed: false,
                message: `Not applicable on the products in the cart.`,
            };
        }
    }
    const totalValueOfFreebies = (_a = (getYStoreProducts || [])) === null || _a === void 0 ? void 0 : _a.reduce((acc, getYStoreProduct) => {
        const { price = 0 } = (0, product_1.getProductPrice)(getYStoreProduct);
        acc += price;
        return acc;
    }, 0);
    const { discountMsg } = (0, exports.getCouponMessage)(coupon);
    if (couponType === types_1.CouponType.FIXED) {
        const discount = (maxDiscount ? Math.min(maxDiscount, getYAmount !== null && getYAmount !== void 0 ? getYAmount : 0) : getYAmount !== null && getYAmount !== void 0 ? getYAmount : 0) +
            totalValueOfFreebies;
        return {
            coupon,
            allowed: true,
            discount,
            message: discountMsg,
        };
    }
    if (couponType === types_1.CouponType.PERCENTAGE) {
        const discount = (maxDiscount
            ? Math.min(maxDiscount, ((getYPercentage !== null && getYPercentage !== void 0 ? getYPercentage : 0) * totalAmount) / 100)
            : ((getYPercentage !== null && getYPercentage !== void 0 ? getYPercentage : 0) * totalAmount) / 100) + totalValueOfFreebies;
        return {
            coupon,
            allowed: true,
            discount,
            message: discountMsg,
        };
    }
    if (couponType === types_1.CouponType.PRODUCT &&
        Array.isArray(getYStoreProducts) &&
        !!(getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.length)) {
        return {
            coupon,
            allowed: true,
            discount: totalValueOfFreebies,
            message: (0, exports.getCouponMessage)(coupon).discountMsg,
        };
    }
    // if (
    //   couponType === CouponType.FREEBIE &&
    //   Array.isArray(getYStoreProducts) &&
    //   !!getYStoreProducts?.length
    // ) {
    //   const totalValueOfFreebies = getYStoreProducts?.reduce(
    //     (acc: number, getYStoreProduct: any) => {
    //       const { price = 0 } = getProductPrice(getYStoreProduct);
    //       acc += price;
    //       return acc;
    //     },
    //     0
    //   );
    //   return {
    //     coupon,
    //     allowed: true,
    //     discount: totalValueOfFreebies,
    //     message: getCouponMessage(coupon).discountMsg,
    //   };
    // }
    // For couponType === BUY_X_GET_Y
    const cartAmounts = [];
    cartList.forEach((c) => {
        cartAmounts.push(...Array(Number(c.qty || 0)).fill(c.price));
        cartAmounts.sort((a, b) => (a > b ? 1 : -1));
    });
    if (couponType === types_1.CouponType.BUY_X_GET_Y) {
        const discountedQty = (0, exports.getBxGyFreeQuantity)(getYQuantity, buyXQuantity, cartList, discountItemThreshold);
        const discountedItems = cartAmounts.slice(0, discountedQty);
        const amt = discountedItems.reduce((a, b) => a + b, 0);
        const discount = (maxDiscount ? Math.min(maxDiscount, amt) : amt) + totalValueOfFreebies;
        return {
            coupon,
            allowed: true,
            discount,
            message: discountMsg,
        };
    }
    if (couponType === types_1.CouponType.BUY_X_AT_Y) {
        const discountedQty = (0, exports.getBxAyOnQuantity)(buyXQuantity, cartList, discountItemThreshold);
        const discountedItems = cartAmounts.slice(0, discountedQty);
        const amt = discountedItems.reduce((a, b) => a + b, 0);
        const discountedAmount = (discountedQty / buyXQuantity) * (getYAmount !== null && getYAmount !== void 0 ? getYAmount : 0);
        const amt1 = discountedAmount < amt ? amt - discountedAmount : 0;
        const discount = (maxDiscount ? Math.min(maxDiscount, amt1) : amt1) + totalValueOfFreebies;
        return {
            coupon,
            allowed: true,
            discount,
            message: discountMsg,
        };
    }
    return {
        coupon,
        allowed: false,
        discount: 0,
        message: "Invalid Coupon",
    };
};
exports.getCouponDiscount = getCouponDiscount;
